var module = angular.module('octopusApp.master');

module.directive('orbicular', ['$window', function (windowRef) {

    // https://github.com/cotag/orbicular

    // Constants here reduce memory requirements of each circle
    var $window = angular.element(windowRef),

        // Cache event strings
        resizeEvents = 'orientationchange resize',

        // Set the rotation of the square
        updateProgress = function (circles, pos, modifiers) {
            var modifiedPos,
                circle,
                i;

            // If total is 0 or negative it can lead to Infinity or NaN values
            if (!isFinite(pos)) {
                pos = 0;
            }

            for (i = 0; i < circles.length; i += 1) {
                if (modifiers[i] === 0) {
                    continue;
                }

                modifiedPos = pos * modifiers[i];
                circle = circles[i];

                circle.css({
                    '-webkit-transform': 'rotate(' + modifiedPos + 'deg)',
                    '-moz-transform': 'rotate(' + modifiedPos + 'deg)',
                    '-ms-transform': 'rotate(' + modifiedPos + 'deg)',
                    '-o-transform': 'rotate(' + modifiedPos + 'deg)',
                    'transform': 'rotate(' + modifiedPos + 'deg)'
                });
            }
        };

    return {
        templateUrl: 'areas/master/getting-started/views/orbicular.html',
        transclude: true,
        restrict: 'EA',
        scope: {
            current: '=progression',
            total: '='
        },
        link: function (scope, element, attrs) {
            var circles = [],
                modifiers = attrs.hasOwnProperty('counterclockwise') ? [-1, 1, -2, 1, 2] : [1, 1, 0, 1, 2],

                // Width must be an even number of pixels for the effect to work.
                setWidth = function () {
                    var width = element.prop('offsetWidth');
                    element.css('font-size', width - (width % 2) + 'px');
                },

                update = function () {
                    angular.element(element.children()[3]).css('display', scope.current === scope.total ? 'inherit' : 'none');
                    
                    updateProgress(circles,
                        Math.min(1, scope.current / scope.total) * 180.0,
                        modifiers
                    );
                };


            /**
             * circles are:
             * 0: .co-full
             * 1: .co-full > .co-fill
             * 2: .co-half
             * 3: .co-half > .co-fill
             * 4: .co-half > .co-fix
             **/
            circles.push(angular.element(element.children()[0]));

            circles.push(angular.element(
                angular.element(
                    element.children()[0]
                ).children()[0]
            ));

            circles.push(angular.element(element.children()[1]));

            circles.push(angular.element(
                angular.element(
                    element.children()[1]
                ).children()[0]
            ));

            circles.push(angular.element(
                angular.element(
                    element.children()[1]
                ).children()[1]
            ));

            // we have to use em's for the clip function to work like a percentage
            // so we have to manually perform the resize based on width
            setWidth();
            scope.$on('orb width', setWidth); // for programmatic resizing

            // Optionally resize
            if (attrs.hasOwnProperty('resize')) {
                scope.$on('$destroy', function () {
                    $window.off(resizeEvents, setWidth);
                });
                $window.on(resizeEvents, setWidth);
            }

            // we watch for changes to the progress indicator of the parent scope
            scope.$watch('current', update);
            scope.$watch('total', update);
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/directives/orbicular.js
// module id = 7923303056379164
// module chunks = 1